import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../core/design-system/components/Button';
import { useCategories } from '../../../../shared/hooks/useCategories';
import './common.css';
import './ActivitiesStep.css';

// Nombre maximum d'activités sélectionnables
const MAX_ACTIVITIES = 3;

const ActivitiesStep = ({ onComplete }) => {
  const { t, i18n } = useTranslation('onboarding');
  const { categories } = useCategories();
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [limitMessage, setLimitMessage] = useState(false);

  const handleActivityToggle = (categoryId) => {
    setSelectedActivities(prev => {
      // Si l'activité est déjà sélectionnée, on peut toujours la désélectionner
      if (prev.includes(categoryId)) {
        return prev.filter(id => id !== categoryId);
      }
      
      // Si on a déjà atteint le maximum et qu'on essaie d'ajouter, on ne fait rien
      if (prev.length >= MAX_ACTIVITIES) {
        // Afficher un message temporaire de limite
        setLimitMessage(true);
        setTimeout(() => setLimitMessage(false), 3000);
        return prev;
      }
      
      // Sinon on ajoute l'activité
      return [...prev, categoryId];
    });
  };

  const handleComplete = () => {
    // S'assurer que les activités sont bien passées comme interests
    onComplete({ 
      activities: selectedActivities,
      interests: selectedActivities // Ajouter aussi comme interests pour la cohérence
    });
  };

  const getSelectedCount = () => {
    return selectedActivities.length > 0 
      ? `(${selectedActivities.length}/${MAX_ACTIVITIES} ${selectedActivities.length === 1 ? 'sélectionnée' : 'sélectionnées'})`
      : '';
  };

  return (
    <div className="activities-step-container">
      <div className="activities-content">
        <div className="activities-dropdown">
          <button 
            className="dropdown-button"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <span>Sélectionner vos activités {getSelectedCount()}</span>
            <span className="dropdown-arrow">{isDropdownOpen ? '▲' : '▼'}</span>
          </button>

          {limitMessage && (
            <div className="activities-limit-message">
              {t('activities.max_selection')}
            </div>
          )}

          {isDropdownOpen && (
            <div className="dropdown-content">
              {categories?.map((category) => (
                <label 
                  key={category.id} 
                  className={`activity-option ${selectedActivities.includes(category.id) ? 'selected' : ''} ${selectedActivities.length >= MAX_ACTIVITIES && !selectedActivities.includes(category.id) ? 'disabled' : ''}`}
                >
                  <input
                    type="checkbox"
                    checked={selectedActivities.includes(category.id)}
                    onChange={() => handleActivityToggle(category.id)}
                    className="activity-checkbox"
                    disabled={selectedActivities.length >= MAX_ACTIVITIES && !selectedActivities.includes(category.id)}
                  />
                  <span className="activity-icon">{category.icon}</span>
                  <span className="activity-label">
                    {category.labels[i18n.language] || category.labels.en}
                  </span>
                </label>
              ))}
            </div>
          )}
        </div>
      </div>
      
      <Button 
        variant="primary"
        className="step-submit-button"
        onClick={handleComplete}
        disabled={selectedActivities.length === 0}
      >
        {t('activities.continue')}
      </Button>
    </div>
  );
};

export default ActivitiesStep; 